"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOrderStats = void 0;
const common_business_1 = require("@pionex-web-kit/common-business");
const react_1 = require("react");
const rxjs_1 = require("rxjs");
const SimpleFuturesAPI_1 = require("../../../apis/SimpleFuturesAPI");
const interface_1 = require("../../../interface");
const utils_1 = require("../utils");
const useListenOrderStatusChange_1 = require("./useListenOrderStatusChange");
/** 仓位统计（后端还不支持 wss 推送；支持后，这个 hooks 和使用的地方都要重构） */
const useOrderStats = (params) => {
    const [state, setState] = (0, react_1.useState)({});
    const isLoading = (0, react_1.useRef)();
    const getData = (0, react_1.useCallback)(() => {
        if (isLoading.current || !params.hasLogin) {
            return;
        }
        isLoading.current = true;
        return SimpleFuturesAPI_1.SimpleFuturesAPI.getStats().subscribe({
            next: (res) => {
                setState({
                    // 后端已经按照 symbol 字母排序
                    data: res.results || [],
                });
                isLoading.current = false;
            },
            error: (err) => {
                setState((oldState) => {
                    return Object.assign(Object.assign({}, oldState), { error: err });
                });
                isLoading.current = false;
            },
        });
    }, [params.hasLogin]);
    /** 清空所有状态 */
    const clear = (0, react_1.useCallback)(() => {
        setState({});
        isLoading.current = undefined;
    }, []);
    // 登录状态切换至未登录，则清空数据
    (0, common_business_1.useUpdateEffect)(() => {
        if (!params.hasLogin) {
            clear === null || clear === void 0 ? void 0 : clear();
        }
    }, [params.hasLogin]);
    // 立即启动，然后每60,000毫秒（1分钟）发出一次
    (0, react_1.useEffect)(() => {
        if (!params.isPageActive) {
            return;
        }
        const timerSubscription = (0, rxjs_1.timer)(0, 60000).subscribe({
            next: getData,
            error: () => { },
        });
        return () => {
            timerSubscription.unsubscribe(); // 清理: 取消订阅
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [params.isPageActive]);
    // 监听事件，刷新统计数据
    (0, react_1.useEffect)(() => {
        // 监听前端下单行为，需要先保证对应新tab能先显示，仓位详细字段，靠仓位状态变化推送再次刷新。
        const orderOpen = utils_1.SimpleFuturesOrderSubject.subscribe({
            next: getData,
            error: () => { },
        });
        return () => {
            orderOpen.unsubscribe();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // 自定义的仓位状态变化推送时，刷新stats
    (0, useListenOrderStatusChange_1.useListenOrderStatusChange)({}, (res) => {
        if (!params.isPageActive) {
            return;
        }
        if (res.mode === interface_1.SimpleFutures.OrderMode.Market && !res.position_id) {
            // 市价单情况下，底层还未开仓成功，刷新stats拿不到有效结果
            return;
        }
        getData();
    }, (wssData) => {
        var _a, _b;
        const portfolio = ((_b = (_a = wssData.bu_order_data) === null || _a === void 0 ? void 0 : _a.portfolio) === null || _b === void 0 ? void 0 : _b[0]) || {};
        return `${wssData.bu_order_id}|${wssData.status}|${portfolio.position_id}`;
    });
    return {
        error: state.error,
        data: state.data,
        refresh: getData,
    };
};
exports.useOrderStats = useOrderStats;
